import type { Building, Stockpile, UnitWire } from '../../shared/types'
import { realmMultiplier, type RealmView } from '../../shared/realm'
import { ITEMS } from '../../shared/constants'

export type OpeningStage = 'hammer' | 'crafting' | 'farm' | 'house' | 'ready'
/** The opening ends with the camp plans; exploration is always optional. */
export function openingStage(me: string, buildings: Iterable<Pick<Building,'owner'|'type'>>, hammerReady = true, hammerQueued = false): OpeningStage {
  if(!hammerReady)return hammerQueued ? 'crafting' : 'hammer'
  const own=[...buildings].filter(b=>b.owner===me)
  if(!own.some(b=>b.type==='farm'||b.type==='pier'))return 'farm'
  if(!own.some(b=>b.type==='house'))return 'house'
  return 'ready'
}

/** Work progress, not an ETA: walking, bonuses and available materials affect pace. */
export function hammerCraftStatus(hall: Building, units: Iterable<Pick<UnitWire, 'owner' | 'hp' | 'job' | 'state'>>, stock?: Partial<Stockpile>, connected = true, realm?: RealmView, tick = 0): { fraction: number; label: string } | null {
  const index = hall.queue.findIndex(order => order.item === 'hammer')
  if (index < 0) return null
  const remaining = Math.max(0, hall.queue[index].ticksLeft)
  const fraction = Math.max(0, Math.min(1, 1 - remaining / ITEMS.hammer.forgeTime))
  if (!connected) return { fraction, label: 'Reconnecting — craft progress will update shortly' }
  if (hall.paused) return { fraction, label: 'Bench paused — resume work to continue' }
  if (index > 0) return { fraction, label: `Hammer queued · ${index} ${index === 1 ? 'order' : 'orders'} ahead` }
  if (remaining <= 0) return { fraction, label: 'Hammer finished — waiting for room in the armory' }
  const nextWood=(ITEMS.hammer.forgeCost.wood! / ITEMS.hammer.forgeTime)*Math.min(remaining,realmMultiplier(realm,'craft',tick))
  if ((stock?.wood ?? 0) < nextWood - 1e-9) return { fraction, label: 'Waiting for wood — gather more supplies' }
  const crew = [...units].filter(unit => unit.owner === hall.owner && unit.hp > 0 && unit.job === hall.id)
  if (crew.some(unit => unit.state === 'working')) return { fraction, label: `Crafting hammer · ${Math.floor(fraction * 100)}% complete` }
  if (crew.length) return { fraction, label: 'Your crafter is fetching wood or walking to the bench' }
  return { fraction, label: 'Hammer queued — waiting for a free founder' }
}
